module.exports = __webpack_public_path__ + "static/media/Image available.39fc4200.svg";